import { MobileProjectsEditPage } from './MobileProjectsEditPage';
import { withMobileProjectsEditPage } from './withMobileProjectsEditPage';

const ConnectedMobileProjectsEditPage = withMobileProjectsEditPage(
  MobileProjectsEditPage
);

export { ConnectedMobileProjectsEditPage as MobileProjectsEditPage };
